import { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { TimelineAPI } from 'api/timeline';
import { GroupedTimelines, Timeline } from 'api/timeline/types';

const getTimelineQueryKey = (companyId: number) => [
  'meetings-timeline',
  companyId,
];

const getGroupByMonthQueryKey = (companyId: number) => [
  'group-by-month',
  companyId,
];

export const useTimelineListQuery = (
  companyId: number,
): UseQueryResult<Timeline[], unknown> => {
  return useQuery({
    queryKey: getTimelineQueryKey(companyId),
    queryFn: () => TimelineAPI.getTimelines(companyId),
  });
};

export const useGroupByMonthQuery = (
  companyId: number,
): UseQueryResult<GroupedTimelines, unknown> => {
  return useQuery({
    queryKey: getGroupByMonthQueryKey(companyId),
    queryFn: () => TimelineAPI.getGroupByMonth(companyId),
  });
};
